export default __webpack_public_path__ + "static/media/cs-no-search-results.deab78d3.svg";